module.exports = __webpack_public_path__ + "static/TruenoSBd-f5512250d17db0ed3f9552d6db19cd60.woff2";